/**
 * Strip html
 * @param {string} string - Text may contain html
 * @return {string} Text without html
 */
export default function (string) {
    return string.replace(/(<([^>]+)>)/gi, '');
}
